import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {withFirebase} from '../Firebase';
import {Visits} from './Visits'
import {Scans} from './Scans'
import {Bonus} from './Bonus'
import Moment from 'moment';
import {Box} from '@theme-ui/components'
import {AuthUserContext, withAuthorization} from '../Session';
import 'react-tabs/style/react-tabs.css';
import Spinner from "react-bootstrap/Spinner";
import sizeof from "firestore-size";
import Button from "react-bootstrap/Button";
import {Logs} from "./Logs";

// at December 9th, 2020, Metalac decided to allow only one stamp per day.
const whenNewLogicForStampsApplied = new Date(2020, 11, 9);

class CustomTooltip extends React.Component {
    render() {
        const {active} = this.props;

        if (active) {
            const {payload, label} = this.props;
            if (payload === null) {
                return null;
            }
            return (
                <div className="custom-tooltip">
                    <p className="value">Value: {payload[0].value}</p>
                    <p className="value">Time: {payload[0].payload["time"]}</p>
                    <p className="value">Date: {payload[0].payload["date"]}</p>
                    <p className="value">Bill: {payload[0].payload["billNumber"]}</p>
                    <p className="value">Company Code: {payload[0].payload["companyCode"]}</p>
                    <p className="value">City: {payload[0].payload["city"]}</p>
                    <p className="value">Country: {payload[0].payload["country"]}</p>
                    <p className="value">Status: {payload[0].payload["status"]}</p>
                    <p className="value">Pos Id: {payload[0].payload["posId"]}</p>
                    <p className="value">Pos username: {payload[0].payload["username"]}</p>
                </div>
            );
        }
        return null;
    }
}

const AlertsPage = ({fakeUid}) => (
    <AuthUserContext.Consumer>
        {authUser => (
            <Box sx={{margin: 20}}>
                <h4>Alerts</h4>
                <h5>Account email: {authUser.email}</h5>
                <ValueCampaignForm authUser={authUser} fakeUid={fakeUid}/>
            </Box>
        )}
    </AuthUserContext.Consumer>
);

let useUID;

class ValueCampaignFormBase extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.fakeUid) {
            useUID = this.props.fakeUid;
        } else {
            useUID = this.props.authUser.uid;
        }
        var date = new Date();
        date.setDate(date.getDate() - 1);
        this.state = {
            company: null,
            loading: false,
            loadingMessage: "",
            aggregateScansPerBillList: [],
            scansBonusList: [],
            scansBonusListEvents: [],
            scansBonusHistoryListEvents: [],
            scans: [],
            scanDateRange: [],
            logs: [],
            tab1Page: 1,
            tab2Page: 1,
            tab3Page: 1,
            tab4Page: 1,
            tab1Filter: new Map(),
            tab2Filter: new Map(),
            tab3Filter: new Map(),
            tab4Filter: new Map(),
            tab5Filter: new Map(),
        };
        this.setTab1Page = this.setTab1Page.bind(this);
        this.setTab2Page = this.setTab2Page.bind(this);
        this.setTab3Page = this.setTab3Page.bind(this);
        this.setTab4Page = this.setTab4Page.bind(this);
        this.setTab1Filter = this.setTab1Filter.bind(this);
        this.setTab2Filter = this.setTab2Filter.bind(this);
        this.setTab3Filter = this.setTab3Filter.bind(this);
        this.setTab4Filter = this.setTab4Filter.bind(this);
        this.setTab5Filter = this.setTab5Filter.bind(this);
        this.fetchScansByUids = this.fetchScansByUids.bind(this);
    }

    componentDidMount() {
        this.setState({loading: true});

        this.companyUnsub = this.props.firebase.company(useUID).onSnapshot(docSnapshot => {
            console.log(`Received doc snapshot: ${docSnapshot}`);
            Moment().locale(docSnapshot.data().country);
            this.setState({
                company: docSnapshot.data()
            });
        }, err => {
            console.log(`Encountered error: ${err}`);
        });
        this.fetchBonusEvents();
        this.fetchBonusEventsHistory();
        this.fetchVisits();
    }

    fetchLogs() {
        this.setState({
            loading: true
        });
        this.props.firebase.logs().get().then(snapshot => {
            let logs = [];
            let index = 0;
            snapshot.forEach(doc => {
                index = index + 1;
                const {uid, companyUid, status, log, time} = doc.data();
                logs.push({
                    index,
                    uid,
                    companyUid,
                    status,
                    log,
                    time: time.toDate()
                })
            });
            this.setState({
                logs: logs,
                loading: false
            });
        }, err => {
            console.log(`Encountered error: ${err}`);
        })
    }
    fetchVisits() {
        return this.props.firebase.visits(useUID)
            .get()
            .then(snapshot => {
                if (snapshot.empty) {
                    console.log('No matching documents.');
                }
                const visitsMap = {};
                let index = 0;
                snapshot.forEach(doc => {
                    const {uid, firstName, gender, birthday, count, value, periodFilled, lastVisit, listOfCities, listOfCompanyCodes, listOfStoresId, period} = doc.data();
                    index = index + 1;
                    visitsMap[uid] = {
                        uid: uid,
                        firstName: firstName,
                        gender: gender,
                        birthday: typeof birthday !== 'undefined' && birthday !== null ? Moment.tz(birthday.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY') : '',
                        count: count,
                        value: value,
                        periodFilled: periodFilled,
                        period: period,
                        listOfCities: typeof listOfCities !== 'undefined' ? listOfCities.join(',') : '',
                        listOfCompanyCodes: typeof listOfCompanyCodes !== 'undefined' ? listOfCompanyCodes.join(',') : '',
                        listOfStoresId: typeof listOfStoresId !== 'undefined' && listOfStoresId !== null ? listOfStoresId.join(',') : '',
                        listOfCitiesArray: typeof listOfCities !== 'undefined' ? listOfCities : [],
                        listOfCompanyCodesArray: typeof listOfCompanyCodes !== 'undefined' ? listOfCompanyCodes : [],
                        listOfStoresIdArray: typeof listOfStoresId !== 'undefined' && listOfStoresId !== null ? listOfStoresId : [],
                        date: Moment.tz(lastVisit.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                        time: Moment.tz(lastVisit.toDate(), 'Europe/Belgrade').format('H:mm:ss')
                    }
                })

                this.setState({
                    visitsMap: visitsMap,
                });
            }, err => {
                console.log(`Encountered error: ${err}`);
            });
    }

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    fetchBonusEvents() {
        this.setState({
            loading: true,
            loadingMessage: "Fetching the Data"
        });
        return this.props.firebase.bonusEventTimeOrder(useUID)
            .get()
            .then(snapshot => {
                if (snapshot.empty) {
                    console.log('No matching documents.');
                    //return;
                }
                let index = 0;
                let scansBonusEventList = [];
                snapshot.forEach(doc => {
                    const {uid, time, valueInBonusPeriod, listOfCities, listOfStoresId, totalValue, totalVisits, lastVisit} = doc.data();
                    index = index + 1;
                    scansBonusEventList.push({
                        name: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM'),
                        index: index,
                        id: doc.id,
                        uid,
                        uidForScanFrequency: uid,
                        totalValue: (Math.round(totalValue * 100) / 100),
                        visits: totalVisits,
                        value: totalValue,
                        city: typeof listOfCities !== 'undefined' ? listOfCities.join(',') : '',
                        storeId: typeof listOfStoresId !== 'undefined' ? listOfStoresId.join(',') : '',
                        date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                        time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                        timestamp: time.toDate(),
                        timestamp1: time.toDate(),
                        visitNum: totalVisits,
                        valueInLastBonusPeriod: Math.round(valueInBonusPeriod * 100) / 100,
                        lastVisit,
                        timeForInsert: time
                    });
                });
                this.setState({
                    scansBonusListEvents: scansBonusEventList,
                    loading: false,
                    loadingMessage: ""
                });
            });
    }

    fetchBonusEventsHistory() {
        this.setState({
            loading: true,
            loadingMessage: "Fetching the Data"
        });
        return this.props.firebase.bonusEventHistoryTimeOrder(useUID)
            .get()
            .then(snapshot => {
                if (snapshot.empty) {
                    console.log('No matching documents.');
                    //return;
                }
                let index = 0;
                let scansBonusEventHistoryList = [];
                snapshot.forEach(doc => {
                    const {uid, time, valueInBonusPeriod, totalValue, totalVisits, lastVisit, listOfCities, listOfStoresId} = doc.data();
                    index = index + 1;
                    scansBonusEventHistoryList.push({
                        name: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM'),
                        index: index,
                        id: doc.id,
                        uid,
                        uidForScanFrequency: uid,
                        totalValue: (Math.round(totalValue * 100) / 100),
                        visits: totalVisits,
                        date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                        time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                        timestamp: time.toDate(),
                        timestamp1: time.toDate(),
                        visitNum: totalVisits,
                        valueInLastBonusPeriod: (Math.round(valueInBonusPeriod * 100) / 100),
                        lastVisit,
                        listOfCities,
                        listOfStoresId,
                        totalVisits,
                        totalValueForInsert: totalValue,
                        timeForInsert: time,
                        valueInBonusPeriodForInsert: valueInBonusPeriod
                    });
                });
                this.setState({
                    scansBonusHistoryListEvents: scansBonusEventHistoryList,
                    loading: false,
                    loadingMessage: ""
                });
            });
    }

    fetchScans() {
        this.setState({
            loading: true,
            loadingMessage: "Fetching the Data"
        });
        const t0 = performance.now();
        return this.props.firebase.scansTimeOrder(useUID)
            .get()
            .then(snapshot => {
                    this.setState({
                        loadingMessage: "Crunching the Data"
                    });
                    const t1 = performance.now();
                    console.log("Call to iterate all scans took " + (t1 - t0) + " milliseconds.");
                    const {visitsMap} = this.state;
                    if (snapshot.empty) {
                        console.log('No matching documents.');
                        //return;
                    }

                    const scansList = [];
                    const scansBonusList = [];
                    const scansBonusListAdded = [];
                    let index = 0;
                    let bonusCountForUid = [];
                    let valueInLastBonusPeriod = [];
                    let visitCountForUid = [];
                    let scanDateRange = [];
                    let totalSize = 0;
                    snapshot.forEach(doc => {
                        totalSize = totalSize + sizeof(doc.data());
                        const {uid, time, billNumber, value, city, country, companyCode, storeId, posId, status, username, period, billTime, voucher, items} = doc.data();
                        let scanTimeDiff = null;
                        if (typeof billTime !== "undefined" && billTime != null) {
                            const diffInTime = time.toDate().getTime() - billTime.toDate().getTime();
                            const diffInSeconds = Math.round(diffInTime / 1000);
                            scanTimeDiff = Math.round((diffInSeconds) * 1000) / 1000;
                        }
                        index = index + 1;
                        if (scanDateRange[uid] === undefined) {
                            scanDateRange[uid] = {
                                startTime: time,
                                endTime: time,
                                visitCount: 1
                            }
                        } else {
                            const startTime = scanDateRange[uid].startTime;
                            const visitCount = scanDateRange[uid].visitCount;
                            scanDateRange[uid] = {
                                startTime: startTime,
                                endTime: time,
                                visitCount: visitCount + 1
                            }
                        }
                        const date = Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY');
                        if (visitCountForUid[uid] === undefined) {
                            visitCountForUid[uid] = 1;
                            valueInLastBonusPeriod[uid] = value;
                        } else {
                            visitCountForUid[uid] = visitCountForUid[uid] + 1;
                            valueInLastBonusPeriod[uid] = valueInLastBonusPeriod[uid] + value;
                        }
                        // scan be counted for bonus only if there is bill number
                        let addCountForBonus = 1;
                        let addDateForBonus = date;
                        if (typeof storeId !== "undefined" && storeId.includes("link") === true) {
                            addCountForBonus = 0;
                            addDateForBonus = null;
                        }
                        if (bonusCountForUid[uid] === undefined) {
                            bonusCountForUid[uid] = {
                                visitDates: [addDateForBonus],
                                count: addCountForBonus
                            };
                        } else {
                            const visitDates = bonusCountForUid[uid].visitDates;
                            const count = bonusCountForUid[uid].count;
                            if (time.toDate() < whenNewLogicForStampsApplied) {
                                visitDates.push(addDateForBonus);
                                bonusCountForUid[uid] = {
                                    visitDates: visitDates,
                                    count: count + addCountForBonus
                                };
                            } else {
                                if (visitDates.includes(addDateForBonus) === false) {
                                    visitDates.push(addDateForBonus);
                                    bonusCountForUid[uid] = {
                                        visitDates: visitDates,
                                        count: count + addCountForBonus
                                    };
                                }
                            }
                        }
                        scansList.push({
                            name: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM'),
                            index: index,
                            id: doc.id,
                            uid,
                            uidForScanFrequency: uid,
                            totalValue: typeof visitsMap[uid] !== 'undefined' ? (Math.round(visitsMap[uid].value * 100) / 100) : '',
                            visits: typeof visitsMap[uid] !== 'undefined' ? visitsMap[uid].count : '',
                            periodFilled: typeof visitsMap[uid] !== 'undefined' ? visitsMap[uid].periodFilled : '',
                            period: typeof visitsMap[uid] !== 'undefined' ? visitsMap[uid].period : '',
                            billNumber,
                            value,
                            city,
                            country,
                            companyCode,
                            storeId,
                            posId,
                            status,
                            username,
                            date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                            time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                            timestamp: time.toDate(),
                            timestamp1: time.toDate(),
                            visitNum: visitCountForUid[uid],
                            bonusNum: bonusCountForUid[uid].count,
                            valueInLastBonusPeriod: typeof valueInLastBonusPeriod[uid] !== 'undefined' ? (Math.round(valueInLastBonusPeriod[uid] * 100) / 100) : '',
                            scanTimeDiff,
                            voucher,
                            items: typeof items !== 'undefined' ? items.map(item => typeof item === 'string' ? item : (item.quantity + " - " + item.name)).join('; ') : '',
                        });
                        if (bonusCountForUid[uid].count > 0 && bonusCountForUid[uid].count % period === 0) {
                            const visitDates = scansBonusListAdded[uid] === undefined ? [] : scansBonusListAdded[uid].visitDates;
                            if (visitDates.includes(date) === false) {
                                visitDates.push(date);
                                scansBonusListAdded[uid] = {
                                    visitDates: visitDates
                                };
                                scansBonusList.push({
                                    name: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM'),
                                    index: index,
                                    id: doc.id,
                                    uid,
                                    uidForScanFrequency: uid,
                                    totalValue: typeof visitsMap[uid] !== 'undefined' ? (Math.round(visitsMap[uid].value * 100) / 100) : '',
                                    visits: typeof visitsMap[uid] !== 'undefined' ? visitsMap[uid].count : '',
                                    date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                                    time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                                    timestamp: time.toDate(),
                                    timestamp1: time.toDate(),
                                    visitNum: visitCountForUid[uid],
                                    valueInLastBonusPeriod: typeof valueInLastBonusPeriod[uid] !== 'undefined' ? (Math.round(valueInLastBonusPeriod[uid] * 100) / 100) : ''
                                });
                                valueInLastBonusPeriod[uid] = 0;
                            }
                        }
                    });

                    console.log("THE S SIZE: ", this.formatBytes(totalSize));

                    if (scansList.length <= 0) {
                        return;
                    }

                    const aggregateUsersPerBill = [...scansList].reduce((r, {billNumber, uid}) => {
                        if (typeof billNumber === "undefined" || billNumber.length === 0) {
                        } else if (!r[billNumber]) r[billNumber] = uid
                        else r[billNumber] = r[billNumber] + ',' + uid;
                        return r;
                    }, {});

                    const aggregateScansPerBillList = [];
                    Object.keys(aggregateUsersPerBill).map(billNumber => {
                        aggregateScansPerBillList.push({
                            uid: aggregateUsersPerBill[billNumber],
                            billNumber: billNumber,
                            usersPerBill: aggregateUsersPerBill[billNumber].split(",").length
                        })
                    });
                    scansBonusList.sort((a, b) => {
                        return b.timestamp - a.timestamp
                    });
                    this.setState({
                        aggregateScansPerBillList: aggregateScansPerBillList,
                        scansBonusList: scansBonusList,
                        scans: scansList,
                        scanDateRange: scanDateRange,
                        loading: false,
                        loadingMessage: "The data was fetched in " + (t1 - t0) + "ms. The size: " + this.formatBytes(totalSize) + ". Scans: " + scansList.length
                    });
                }, err => {
                    this.setState({
                        loading: false,
                        loadingMessage: "Some Error. Try again later!"
                    });
                    console.log(`Encountered error: ${err}`);
                }
            );
    }

    fetchScansByUids(uids) {
        this.setState({
            loading: true,
            loadingMessage: "Fetching scans by UIDs..."
        });

        // Firestore 'in' query supports max 30 items, so we batch if needed
        const BATCH_SIZE = 30;
        const batches = [];
        for (let i = 0; i < uids.length; i += BATCH_SIZE) {
            batches.push(uids.slice(i, i + BATCH_SIZE));
        }

        const promises = batches.map(batch =>
            this.props.firebase.scansTimeOrder(useUID)
                .where('uid', 'in', batch)
                .get()
        );

        return Promise.all(promises)
            .then(snapshots => {
                const {visitsMap} = this.state;
                const scansList = [];
                let index = 0;
                let bonusCountForUid = [];
                let valueInLastBonusPeriod = [];
                let visitCountForUid = [];
                let scanDateRange = [];

                snapshots.forEach(snapshot => {
                    snapshot.forEach(doc => {
                        const {uid, time, billNumber, value, city, country, companyCode, storeId, posId, status, username, period, billTime, voucher, items} = doc.data();
                        let scanTimeDiff = null;
                        if (typeof billTime !== "undefined" && billTime != null) {
                            const diffInTime = time.toDate().getTime() - billTime.toDate().getTime();
                            const diffInSeconds = Math.round(diffInTime / 1000);
                            scanTimeDiff = Math.round((diffInSeconds) * 1000) / 1000;
                        }
                        index = index + 1;

                        if (scanDateRange[uid] === undefined) {
                            scanDateRange[uid] = {
                                startTime: time,
                                endTime: time,
                                visitCount: 1
                            }
                        } else {
                            const startTime = scanDateRange[uid].startTime;
                            const visitCount = scanDateRange[uid].visitCount;
                            scanDateRange[uid] = {
                                startTime: startTime,
                                endTime: time,
                                visitCount: visitCount + 1
                            }
                        }

                        const date = Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY');
                        if (visitCountForUid[uid] === undefined) {
                            visitCountForUid[uid] = 1;
                            valueInLastBonusPeriod[uid] = value;
                        } else {
                            visitCountForUid[uid] = visitCountForUid[uid] + 1;
                            valueInLastBonusPeriod[uid] = valueInLastBonusPeriod[uid] + value;
                        }

                        let addCountForBonus = 1;
                        let addDateForBonus = date;
                        if (typeof storeId !== "undefined" && storeId.includes("link") === true) {
                            addCountForBonus = 0;
                            addDateForBonus = null;
                        }
                        if (bonusCountForUid[uid] === undefined) {
                            bonusCountForUid[uid] = {
                                visitDates: [addDateForBonus],
                                count: addCountForBonus
                            };
                        } else {
                            const visitDates = bonusCountForUid[uid].visitDates;
                            const count = bonusCountForUid[uid].count;
                            if (time.toDate() < whenNewLogicForStampsApplied) {
                                visitDates.push(addDateForBonus);
                                bonusCountForUid[uid] = {
                                    visitDates: visitDates,
                                    count: count + addCountForBonus
                                };
                            } else {
                                if (visitDates.includes(addDateForBonus) === false) {
                                    visitDates.push(addDateForBonus);
                                    bonusCountForUid[uid] = {
                                        visitDates: visitDates,
                                        count: count + addCountForBonus
                                    };
                                }
                            }
                        }

                        scansList.push({
                            name: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM'),
                            index: index,
                            id: doc.id,
                            uid,
                            uidForScanFrequency: uid,
                            totalValue: typeof visitsMap[uid] !== 'undefined' ? (Math.round(visitsMap[uid].value * 100) / 100) : '',
                            visits: typeof visitsMap[uid] !== 'undefined' ? visitsMap[uid].count : '',
                            periodFilled: typeof visitsMap[uid] !== 'undefined' ? visitsMap[uid].periodFilled : '',
                            period: typeof visitsMap[uid] !== 'undefined' ? visitsMap[uid].period : '',
                            billNumber,
                            value,
                            city,
                            country,
                            companyCode,
                            storeId,
                            posId,
                            status,
                            username,
                            date: Moment.tz(time.toDate(), 'Europe/Belgrade').format('DD.MM.YYYY'),
                            time: Moment.tz(time.toDate(), 'Europe/Belgrade').format('H:mm:ss'),
                            timestamp: time.toDate(),
                            timestamp1: time.toDate(),
                            visitNum: visitCountForUid[uid],
                            bonusNum: bonusCountForUid[uid].count,
                            valueInLastBonusPeriod: typeof valueInLastBonusPeriod[uid] !== 'undefined' ? (Math.round(valueInLastBonusPeriod[uid] * 100) / 100) : '',
                            scanTimeDiff,
                            voucher,
                            items: typeof items !== 'undefined' ? items.map(item => typeof item === 'string' ? item : (item.quantity + " - " + item.name)).join('; ') : '',
                        });
                    });
                });

                this.setState({
                    scans: scansList,
                    scanDateRange: scanDateRange,
                    loading: false,
                    loadingMessage: `Found ${scansList.length} scans for ${uids.length} UIDs`
                });

                console.log(`Found ${scansList.length} scans for ${uids.length} UIDs`);
            })
            .catch((err) => {
                console.log(`Error fetching scans by UIDs: ${err}`);
                this.setState({
                    loading: false,
                    loadingMessage: "Error fetching scans by UIDs"
                });
            });
    }

    componentWillUnmount() {

    }

    optionalTab1ForMetalac(show) {
        if (!show) return null;
        return (
            <Tab>Bonus - Nightly File</Tab>
        )
    }

    optionalTab3ForMetalac(show) {
        if (!show) return null;
        return (
            <Tab>Scan per Bill Number</Tab>
        )
    }

    optionalTab4ForDK(show) {
        if (!show) return null;
        return (
            <Tab>Logs</Tab>
        )
    }

    optionalTab1ContentForMetalac(
        show,
        scansBonusHistoryListEvents,
        scansBonusListEvents,
        scanDateRange
    ) {
        if (!show) return null;
        return (
            <TabPanel>
                <div>
                    <Button variant="warning" onClick={() => this.fetchBonusEventsHistory()}>Refresh</Button>
                </div>
                <Bonus scans={scansBonusHistoryListEvents} bonusForCompare={scansBonusListEvents}
                       scanDateRange={scanDateRange} page={this.state.tab2Page} setPage={this.setTab2Page}
                       filter={this.state.tab2Filter} setFilter={this.setTab2Filter}/>
            </TabPanel>
        )
    }

    optionalTab3ContentForMetalac(show, aggregateScansPerBillList) {
        if (!show) return null;
        return (
            <TabPanel>
                <div>
                    <Button variant="warning" onClick={() => this.fetchScans()}>Load! - Long
                        Operation</Button>
                </div>
                <Visits visits={aggregateScansPerBillList}/>
            </TabPanel>
        )
    }

    optionalTab4ContentForDK(show, logs) {
        if (!show) return null;
        return (
            <TabPanel>
                <div>
                    <Button variant="warning" onClick={() => this.fetchLogs()}>Load</Button>
                </div>
                <Logs logs={logs} filter={this.state.tab5Filter} setFilter={this.setTab5Filter}/>
            </TabPanel>
        )
    }

    setTab1Page(page) {
        this.setState({tab1Page: page});
    }
    setTab2Page(page) {
        this.setState({tab2Page: page});
    }
    setTab3Page(page) {
        this.setState({tab3Page: page});
    }
    setTab4Page(page) {
        this.setState({tab4Page: page});
    }

    setTab1Filter(key, value) {
        if(this.state.tab1Filter.has(key) && this.state.tab1Filter.get(key) === value) {
            return;
        }
        let newFilter = new Map();
        this.state.tab1Filter.forEach((value, key) => {
            newFilter.set(key, value)
        });
        newFilter.set(key, value);
        this.setState({tab1Filter: newFilter})
    }

    setTab2Filter(key, value) {
        if(this.state.tab2Filter.has(key) && this.state.tab2Filter.get(key) === value) {
            return;
        }
        let newFilter = new Map();
        this.state.tab2Filter.forEach((value, key) => {
            newFilter.set(key, value)
        });
        newFilter.set(key, value);
        this.setState({tab2Filter: newFilter})
    }

    setTab3Filter(key, value) {
        if(this.state.tab3Filter.has(key) && this.state.tab3Filter.get(key) === value) {
            return;
        }
        let newFilter = new Map();
        this.state.tab3Filter.forEach((value, key) => {
            newFilter.set(key, value)
        });
        newFilter.set(key, value);
        this.setState({tab3Filter: newFilter})
    }

    setTab4Filter(key, value) {
        if(this.state.tab4Filter.has(key) && this.state.tab4Filter.get(key) === value) {
            return;
        }
        let newFilter = new Map();
        this.state.tab4Filter.forEach((value, key) => {
            newFilter.set(key, value)
        });
        newFilter.set(key, value);
        this.setState({tab4Filter: newFilter})
    }

    setTab5Filter(key, value) {
        if(this.state.tab5Filter.has(key) && this.state.tab5Filter.get(key) === value) {
            return;
        }
        let newFilter = new Map();
        this.state.tab5Filter.forEach((value, key) => {
            newFilter.set(key, value)
        });
        newFilter.set(key, value);
        this.setState({tab5Filter: newFilter})
    }

    render() {
        const {company, scansBonusList, scansBonusListEvents, scansBonusHistoryListEvents, loading, loadingMessage, aggregateScansPerBillList, scans, scanDateRange, logs} = this.state;
        let scansBonusListEventsForCompare = null;
        if (useUID === "rftyEcoF57d5H2gD0Rcqqa2ngV63") {
            scansBonusListEventsForCompare = scansBonusHistoryListEvents;
        }
        return (
            <div>
                <h2>Company: {company != null ? company.name : ''} </h2><br/>
                {loading && <Spinner animation="border" variant="primary"/>}
                {loadingMessage}
                <hr/>
                <div>
                    <Tabs>
                        <TabList>
                            <Tab>Bonus - Events</Tab>
                            {this.optionalTab1ForMetalac(useUID === "rftyEcoF57d5H2gD0Rcqqa2ngV63")}
                            <Tab>Scans</Tab>
                            {this.optionalTab3ForMetalac(useUID === "rftyEcoF57d5H2gD0Rcqqa2ngV63")}
                            {this.optionalTab4ForDK(this.props.authUser.uid === "1Rp46TPvHCfEJaddNPqnAL7DTHm1")}
                        </TabList>
                        <TabPanel>
                            <div>
                                <Button variant="warning" onClick={() => this.fetchBonusEvents()}>Refresh</Button>
                            </div>
                            <Bonus scans={scansBonusListEvents} bonusForCompare={scansBonusListEventsForCompare}
                                   scanDateRange={scanDateRange} page={this.state.tab1Page} setPage={this.setTab1Page}
                                    filter={this.state.tab1Filter} setFilter={this.setTab1Filter}/>
                        </TabPanel>
                        {this.optionalTab1ContentForMetalac(
                            useUID === "rftyEcoF57d5H2gD0Rcqqa2ngV63",
                            scansBonusHistoryListEvents,
                            scansBonusListEvents,
                            scanDateRange
                        )}
                        <TabPanel>
                            <div>
                                <Button variant="warning" onClick={() => this.fetchScans()}>Load! - Long
                                    Operation</Button>
                            </div>
                            <Scans scans={scans} company={company} allScans={scans} scanDateRange={scanDateRange}
                                   page={this.state.tab4Page} setPage={this.setTab4Page}
                                   filter={this.state.tab4Filter} setFilter={this.setTab4Filter}
                                   fetchScansByUids={this.fetchScansByUids}/>
                        </TabPanel>
                        {this.optionalTab3ContentForMetalac(
                            useUID === "rftyEcoF57d5H2gD0Rcqqa2ngV63",
                            aggregateScansPerBillList
                        )}
                        {this.optionalTab4ContentForDK(
                            this.props.authUser.uid === "1Rp46TPvHCfEJaddNPqnAL7DTHm1" && window.location.hostname === "localhost",
                            logs
                        )}
                    </Tabs>
                </div>
            </div>
        );
    }
}

const ValueCampaignForm = withFirebase(ValueCampaignFormBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(AlertsPage);
